import React from 'react';
import { Form, Input } from 'antd';
// Components
import FormSection from '../FormSection/FormSection';
// Style
import styles from '../CampaignEditComponents.module.scss';

type CompanyDetailsProps = {
  renderCustomFields?: () => React.ReactNode;
};

const CompanyDetails = ({
  renderCustomFields,
}: CompanyDetailsProps): JSX.Element => {
  return (
    <FormSection title="Company" hint="The brand behind the campaign.">
      <div className={styles.rowWrapper}>
        <Form.Item
          name="brandName"
          rules={[
            {
              required: true,
              message: 'This field is required',
            },
          ]}
          label="Company Name"
        >
          <Input
            type="text"
            placeholder="Enter company name"
            aria-label="Enter company name"
          />
        </Form.Item>
        <Form.Item name="website" label="Company Website">
          <Input
            type="text"
            placeholder="https://example.com"
            aria-label="https://example.com"
          />
        </Form.Item>
      </div>

      {renderCustomFields?.()}
    </FormSection>
  );
};

export default CompanyDetails;
